var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{'match-status-suspended': _vm.status === 'Suspended'}},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }